var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.3029 8L11.9997 12.3041L7.69649 8L5.84766 9.84883L11.9997 16L18.1517 9.84883L16.3029 8Z"}));
}

ChevronDownInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
